import { Button } from '~/DesignSystem/components/button'
import { cn } from '~/DesignSystem/lib/utils'

function MessageActions({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('grid grid-cols-2 gap-2', className)} {...props} />
}

function MessageAction({
  variant = 'default',
  className,
  ...props
}: React.ComponentProps<typeof Button>) {
  return <Button variant={variant} className={cn('w-full', className)} {...props} />
}

export { MessageAction, MessageActions }
